const sortDates = [
  {
    label: 'По времени публикации',
    value: 'by_time_of_publication',
  },
  {
    label: 'Сначала дешевые',
    value: 'cheaper',
  },
  {
    label: 'Сначала дорогие',
    value: 'more_expensive',
  },
  {
    label: 'Сначала новые ТС',
    value: 'new_first',
  },
  {
    label: 'Сначала старые ТС',
    value: 'first_old',
  },
  {
    label: 'По пробегу',
    value: 'mileage',
  },
  {
    label: 'По моточасам',
    value: 'working_hours',
  },
  {
    label: 'По названию',
    value: 'by_name',
  },
];

export default sortDates;
